export const DOMAIN_PURCHASE_INTENT_FUNNEL =
  'add-domain-purchase-intent-funnel';

export const FUNNEL_PATH = '/premium-domains/premium-funnel';

export const getFunnelSplitPageUrl = (domainName: string) =>
  `${FUNNEL_PATH}/?step=split&domainName=${encodeURIComponent(domainName)}`;
